import { createTheme } from '@mui/material/styles';

// TODO: we have some global css overrides, since our pages use both MUI and Bootstrap 5 for styling.
// https://mui.com/material-ui/customization/palette
export const themeAttuned = createTheme({
  palette: {
    //
    // ---- Official palette (primary, secondary, error, warning, info, success) ----
    //
    primary: {
      main: '#346189',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: '#e3ebf0',
      contrastText: '#193962',
    },
    // error: {}
    // warning: {}
    // info: {}
    // success: {}

    //
    // ---- Custom colors ----
    //
    // Note: tokens for custom colors are not automatically calculated.
    brand: {
      main: '#67BBB9',
      dark: '#488281',
      light: '#85C8C7',
      contrastText: '#fff',
    },
    // The middle rung of the R/Y/G goal-status scale (#7876). It's a token rather than
    // palette.warning because warning is an orange: white-on-#ED6C02 is 3.11:1 against the 4.5:1
    // floor for text, and it sits only 1.60:1 from palette.error, so "near target" and "off track"
    // read as the same signal in a column of goals. Amber 500 carries the app's ordinary text ink
    // at 10.70:1 and stands 3.05:1 clear of the red. Only the three status bands use this; warning
    // keeps its value so the stale-goal icon, Overdue chips, snackbars and alerts don't shift.
    // Chip needs all of main/dark/contrastText present to generate its color variants
    // (createSimplePaletteValueFilter); dark is MUI's own darken(main, 0.2).
    bandYellow: {
      main: '#FFC107',
      dark: '#CC9A05',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    // The favorite star on My Orgs and CARE My Work (FavoriteStarButton, #7930); `dark` is its hover color.
    favoriteStar: {
      main: '#FFB800',
      dark: '#E6A600',
    },
    text: {
      main: '#193962',
    },
  },

  // component overrides
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          fontWeight: 400,
          '&:hover': {
            boxShadow: 'none',
          },
          '&:focus': {
            boxShadow: 'none',
          },
        },
        containedSecondary: {
          color: '#193962',
          backgroundColor: '#e3ebf0',
          '&:hover': {
            backgroundColor: '#dce3e8',
          },
          '& .MuiTouchRipple-root': {
            color: '#b3bcc5',
          },
          '&.Mui-disabled': {
            backgroundColor: '#e3ebf0',
            color: '#9a9a9a',
            opacity: 0.5,
          },
        },
        containedBrand: {
          color: '#fff',
          backgroundColor: '#67BBB9',
          '&:hover': {
            backgroundColor: '#488281',
          },
          '& .MuiTouchRipple-root': {
            color: '#3a6b6a',
          },
          '&.Mui-disabled': {
            backgroundColor: '#67BBB9',
            color: '#fff',
            opacity: 0.5,
          },
        },
        outlinedPrimary: {
          '&.Mui-disabled': {
            color: '#346189',
            borderColor: '#346189',
            opacity: 0.5,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '& .MuiTableRow-root:last-child td, & .MuiTableRow-root:last-child th': {
            border: 0,
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          // Horizontal padding aligns with <DialogContent> padding
          padding: '12px 24px 12px 24px',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: '500',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            cursor: 'pointer',
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.severity === 'success' &&
            ownerState.variant === 'filled' && {
              backgroundColor: '#67BBB9',
              color: '#ffffff',
            }),
        }),
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '0.875rem',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(0, 0, 0, 0.08)',
        },
      },
    },
  },
});

export const transparentButtonSX = {
  backgroundColor: 'transparent',
  boxShadow: 'none',
  color: 'initial',
  ':hover': {
    color: 'initial',
    backgroundColor: 'initial',
    boxShadow: 'none',
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
  disableRipple: true,
};

// Gray outlined button - neutral borders that darken on hover, no background change
export const grayOutlinedButtonSx = {
  color: 'text.secondary',
  borderColor: 'rgba(0, 0, 0, 0.23)',
  '&:hover': {
    borderColor: 'rgba(0, 0, 0, 0.5)',
    backgroundColor: 'transparent',
  },
};
